/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popLuckyboxNewTip.vue?vue&type=template&id=1b38edcc&scoped=true"
import script from "./popLuckyboxNewTip.vue?vue&type=script&lang=js"
export * from "./popLuckyboxNewTip.vue?vue&type=script&lang=js"
import style0 from "./popLuckyboxNewTip.vue?vue&type=style&index=0&id=1b38edcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b38edcc",
  null
  
)

export default component.exports